export default "__VITE_ASSET__e1n28qf7__"